import { useCallback } from 'react';

import { useMutation } from '@apollo/client/react';

import { useAmplifyServiceContext } from '../../services';

import {
  AddCommentToEventDocument,
  AddCommentToEventMutationVariables,
} from './Event.mutation.generated';

let TEMP_ID = 0;
const getTempId = () => {
  TEMP_ID++;
  return TEMP_ID * -1000000;
};

export const useEventAddComment = () => {
  const [runMutation, status] = useMutation(AddCommentToEventDocument);
  const { user } = useAmplifyServiceContext();

  const execute = useCallback(
    async (variables: AddCommentToEventMutationVariables) => {
      const res = await runMutation({
        variables,
        optimisticResponse: {
          __typename: 'mutation_root' as const,
          insert_lives_post_one: {
            __typename: 'lives_post' as const,
            // string ISO comme la réponse serveur (le tri utilise localeCompare)
            _created: new Date().toISOString(),
            id: getTempId(),
            data: variables.data,
            picture: variables.picture ?? undefined,
            live_id: variables.liveId,
            // @ts-expect-error we can't use undefined
            action_id: null,
            // @ts-expect-error we can't use undefined
            action: null,
            team_official_reporter_id:
              variables.teamOfficialReporterId ?? undefined,
            spectator: {
              __typename: 'lives_spectator' as const,
              id: getTempId(),
              name: user?.info?.username,
              picture_url: user?.info?.picture_url,
              user_id: user?.info?.id,
            },
          },
        },
        // update: (cache, res) => {
        //   cache.updateQuery(
        //     {
        //       query: LivePostOptimiscUpdateDocument,
        //       returnPartialData: true,
        //       variables: {
        //         liveId: variables.liveId,
        //       },
        //     },
        //     (data) => {
        //       return {
        //         __typename: 'query_root' as const,
        //         lives_post: res?.data?.insert_lives_post_one
        //           ? [
        //               res?.data?.insert_lives_post_one,
        //               ...(data?.lives_post || []),
        //             ]
        //           : data?.lives_post || [],
        //         lives_post_aggregate: {
        //           __typename: 'lives_post_aggregate' as const,
        //           aggregate: {
        //             __typename: 'lives_post_aggregate_fields' as const,
        //             count:
        //               (data?.lives_post_aggregate?.aggregate?.count || 0) + 1,
        //           },
        //         },
        //       };
        //     }
        //   );
        // },
      });
      return res;
    },
    [runMutation]
  );

  return { execute, status };
};
